import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LightTooltip from "../../commonComponents/LightTooltip";

export default function AiAutoMapButton({buttonEnabled, handleAiButtonClick, hasInboundDependency}) {
  const { t } = useTranslation();
  const tooltipTitle = hasInboundDependency ? t("AI_BTN_TOOLTIP") : t("AI_BTN_TOOLTIP_NO_DEPENDENCY");

  return (
    <>
      <LightTooltip
        //untranslated title for POC phase 
        title={tooltipTitle}
      >
        <span>
          <Button
            size='small'
            variant="text"
            sx={{ minWidth: "32px !important", height: "31px !important" }}
            onClick={handleAiButtonClick}
            disabled={!buttonEnabled}
          >
            <span className={"AI_GREY" + (buttonEnabled ? "" : " op-5")}></span>
          </Button>
        </span>
        
      </LightTooltip>

    </>
  );
}
